<template>
  <div class="select-ajax">
    <Input
      type="text"
      readonly
      :label="`${label} ${ contador ? '('+lista.length+')' : ''}`"
      v-model="selecionado"
      :disabled="disabled"
      @click="handleSearch"
      class="selecionado"
      @focus="exibe = true"
      @blur="onBlurSelecionado"
      iconRight="arrow_drop_down"
      :validation="validation"
      :v="v"
    />
    <div @mouseover="active = true" class="select-ajax-lista" v-show="(lista.length > 0 || transicao) && exibe">
      <div class="item" v-if="transicao" @click="exibe = false">{{ this.transicao }}</div>
      <div v-else>
        <div :class="{ active: item.key == value && !active, item: true }" v-for="item in lista" :key="item.key" @click="onClick(item)">
          <span>{{ item.value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import Input from "./Input";

export default {
  name: "SelectAjax",
  components: { Input },
  props: {
    value: [ String, Number, Object, Array ],
    chave: [ String, Number, Function ],
    valor: [ String, Number, Function ],
    label: String,
    disabled: {
      type: Boolean,
      default: false
    },
    validation: {
      type: Boolean,
      default: false
    },
    rota: {
      type: String,
      default: ''
    },
    resultado: {
      type: Array,
      default() { return [] }
    },
    params: {
      type: Object,
      default: () => {}
    },
    contador: {
      type: Boolean,
      default: false
    },
    opcaoTodos: {
      type: String,
      default: ''
    },
    listaLocal: {
      type: Array,
      default() { return [] }
    },
    v: {
      type: Object,
      default() {
        return {
          $invalid: false,
          $dirty: false,
          $touch: () => {},
        };
      },
    },
  },
  mounted() {
    this.lista = this.listaLocal ? this.listaLocal : [];
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal === '') return;
      const selecionado = this.lista.find( (item) => item.key == newVal);
      if (selecionado !== undefined) this.selecionado = selecionado.value;
    },
    listaLocal(val) {
      if (val === null) {
        this.lista = [];
        this.selecionado = "";
        return;
      }
      this.lista = val;
      const selecionado = this.lista.find( (item) => item.key == this.value);
      if (selecionado !== undefined) this.selecionado = selecionado.value;
    }
  },
  data() {
    return {
      lista: [],
      transicao: "",
      selecionado: "",
      exibe: false,
      active: false,
    };
  },
  methods: {
    handleSearch() {
      if (this.lista.length > 0) return;

      this.transicao = "Carregando...";

      api(this.rota, { params: this.params })
        .then(response => {
          if (!this.exibe || this.lista.length > 0) return;

          let dataResult = response.data.results;
          if (this.resultado.length) {
            for ( let path of this.resultado ) {
              dataResult = dataResult[path];
            }
          }

          if (dataResult.length <= 0) {
            this.transicao = "Nenhum encontrado.";
            return;
          }

          for (const key in dataResult) {
            this.lista.push({
              key: typeof(this.chave) === "function" ? this.chave(dataResult[key]) : dataResult[key][this.chave],
              value: typeof(this.valor) === "function" ? this.valor(dataResult[key]) : dataResult[key][this.valor]
            });
          }

          if (this.opcaoTodos && this.lista.length > 0) this.lista.unshift({key: -1, value: this.opcaoTodos});

          this.transicao = "";
        })
        .catch(() => {
          this.transicao = "Nenhum encontrado.";
        });
    },
    limpar() {
      this.lista = [];
      this.selecionado = "";
      this.$emit('input', '');
      this.$emit('change', null);
    },
    obterlista() {
      return this.lista;
    },
    async onClick(dados) {
      this.$emit('input', dados.key);
      this.$emit('change', dados.key);
      this.exibe = false;
    },
    onBlurSelecionado() {
      setTimeout(() => {this.exibe = false; this.active = false}, 250);
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/css/selectAjax.scss";
</style>
